import angular from 'angular';
import uiRouter from 'angular-ui-router';
import taxationInvoicesComponent from './invoices.component';


const taxationInvoicesModule = angular.module('tinaba.components.taxation.invoices', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('taxation.invoices', {
      url: '/invoices',
      template: '<invoices></invoices>'
    });
})

.component('invoices', taxationInvoicesComponent);

export default taxationInvoicesModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/taxation/invoices/invoices.js
 **/